<template>
    <Modal v-if="mobile" :show="showModalSellerInfo" @close="$emit('close:modal')" :isNowrap="true" :modalClass="'seller-tooltip-modal'">
        <button @click="$emit('close:modal')" type="button" class="main-card__close-btn close" data-dismiss="modal" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.0486 0.334961C14.4949 -0.111352 15.2185 -0.111352 15.6648 0.334961C16.1111 0.781274 16.1111 1.50486 15.6648 1.95117L9.61597 8L15.6648 14.0488C16.1111 14.4951 16.1111 15.2187 15.6648 15.665C15.2185 16.1114 14.4949 16.1114 14.0486 15.665L7.99976 9.61621L1.95093 15.665C1.50461 16.1114 0.78103 16.1114 0.334717 15.665C-0.111596 15.2187 -0.111597 14.4951 0.334717 14.0488L6.38354 8L0.334717 1.95117C-0.111597 1.50486 -0.111597 0.781274 0.334717 0.334961C0.78103 -0.111353 1.50461 -0.111353 1.95093 0.334961L7.99976 6.38379L14.0486 0.334961Z" fill="#C9C9C9"/>
            </svg>
        </button>
        <OfferSellerInfo :offer="offer" :seller="seller" :elClass="'tool'" />
        <div class="seller-tooltip__row rate">
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Success rate') }}:</span>
                <span class="seller-tooltip__row-col-value">{{ formatCurrency(seller?.success_rate, true) }}</span>
            </div>
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Total feedbacks') }}:</span>
                <span class="seller-tooltip__row-col-value">{{ formatCurrency(seller?.count_reviews_as_seller) }}</span>
            </div>
        </div>
        <div class="seller-tooltip__row">
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Seller time zone') }}:</span>
                <span class="seller-tooltip__row-col-value">{{ getUtcOffset(seller?.timezone, seller?.updated_at) }}</span>
            </div>
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Total trades') }}:</span>
                <span class="seller-tooltip__row-col-value">{{ seller?.completed_sales_count }}</span>
            </div>
        </div>
        <div class="seller-tooltip__row feedbacks">
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Positive feedbacks') }}:</span>
                <span class="seller-tooltip__row-col-value positive">{{ formatCurrency(seller?.percent_of_positive_feedbacks, true) }}</span>
            </div>
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Negative feedbacks') }}:</span>
                <span class="seller-tooltip__row-col-value negative">{{ getNegativeFeedback(seller?.percent_of_positive_feedbacks, seller?.count_reviews_as_seller) }}</span>
            </div>
        </div>
        <a :href="'/' + language + '/chats/addconversation?userIdTarget=' + seller?.id" class="seller-tooltip__btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.1986 18.4385C21.8525 15.3774 21.5268 10.7612 18.5326 8.08203C20.0705 13.4713 16.0038 18.8546 10.4008 18.8546C10.2929 18.8546 10.9439 18.8584 8.37988 18.8426C9.78223 20.2384 11.65 20.9991 13.5999 20.9991C13.6049 20.9991 20.471 20.964 20.4751 20.964C20.9438 20.9617 21.1773 20.3913 20.8429 20.0613L19.1986 18.4385Z" fill="#F6F6F6"/>
                <path d="M10.4004 17.8008C14.4808 17.8008 17.8004 14.481 17.8004 10.4004C17.8004 6.3198 14.4808 3 10.4004 3C6.31999 3 3.00043 6.3198 3.00043 10.4004C3.00043 12.1968 3.63634 13.8959 4.80173 15.2401L3.15733 16.8629C2.82405 17.1919 3.05492 17.7633 3.52524 17.7656C3.52886 17.7657 10.3968 17.8008 10.4004 17.8008ZM7.25409 7.78125H13.5819C13.8731 7.78125 14.1092 8.01736 14.1092 8.30859C14.1092 8.59983 13.8731 8.83594 13.5819 8.83594H7.25409C6.96285 8.83594 6.72678 8.59983 6.72678 8.30859C6.72678 8.01736 6.96289 7.78125 7.25409 7.78125ZM7.25409 9.89062H13.5819C13.8731 9.89062 14.1092 10.1267 14.1092 10.418C14.1092 10.7092 13.8731 10.9453 13.5819 10.9453H7.25409C6.96285 10.9453 6.72678 10.7092 6.72678 10.418C6.72678 10.1267 6.96289 9.89062 7.25409 9.89062ZM6.72678 12.5273C6.72678 12.2361 6.96285 12 7.25409 12H13.5819C13.8731 12 14.1092 12.2361 14.1092 12.5273C14.1092 12.8186 13.8731 13.0547 13.5819 13.0547H7.25409C6.96289 13.0547 6.72678 12.8186 6.72678 12.5273Z" fill="#F6F6F6"/>
            </svg>
            <span>{{ $t('Chat') }}</span>
        </a>
    </Modal>
    <div class="seller-tooltip" v-else>
        <OfferSellerInfo :offer="offer" :seller="seller" :elClass="'tool'" />
        <div class="seller-tooltip__row rate">
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Success rate') }}:</span>
                <span class="seller-tooltip__row-col-value">{{ formatCurrency(seller?.success_rate, true) }}</span>
            </div>
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Total feedbacks') }}:</span>
                <span class="seller-tooltip__row-col-value">{{ formatCurrency(seller?.count_reviews_as_seller) }}</span>
            </div>
        </div>
        <div class="seller-tooltip__row">
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Seller time zone') }}:</span>
                <span class="seller-tooltip__row-col-value">{{ getUtcOffset(seller?.timezone, seller?.updated_at) }}</span>
            </div>
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Total trades') }}:</span>
                <span class="seller-tooltip__row-col-value">{{ seller?.completed_sales_count }}</span>
            </div>
        </div>
        <div class="seller-tooltip__row feedbacks">
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Positive feedbacks') }}:</span>
                <span class="seller-tooltip__row-col-value positive">{{ formatCurrency(seller?.percent_of_positive_feedbacks, true) }}</span>
            </div>
            <div class="seller-tooltip__row-col">
                <span class="seller-tooltip__row-col-text">{{ $t('Negative feedbacks') }}:</span>
                <span class="seller-tooltip__row-col-value negative">{{ getNegativeFeedback(seller?.percent_of_positive_feedbacks, seller?.count_reviews_as_seller) }}</span>
            </div>
        </div>
        <a :href="'/' + language + '/chats/addconversation?userIdTarget=' + seller?.id" class="seller-tooltip__btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.1986 18.4385C21.8525 15.3774 21.5268 10.7612 18.5326 8.08203C20.0705 13.4713 16.0038 18.8546 10.4008 18.8546C10.2929 18.8546 10.9439 18.8584 8.37988 18.8426C9.78223 20.2384 11.65 20.9991 13.5999 20.9991C13.6049 20.9991 20.471 20.964 20.4751 20.964C20.9438 20.9617 21.1773 20.3913 20.8429 20.0613L19.1986 18.4385Z" fill="#F6F6F6"/>
                <path d="M10.4004 17.8008C14.4808 17.8008 17.8004 14.481 17.8004 10.4004C17.8004 6.3198 14.4808 3 10.4004 3C6.31999 3 3.00043 6.3198 3.00043 10.4004C3.00043 12.1968 3.63634 13.8959 4.80173 15.2401L3.15733 16.8629C2.82405 17.1919 3.05492 17.7633 3.52524 17.7656C3.52886 17.7657 10.3968 17.8008 10.4004 17.8008ZM7.25409 7.78125H13.5819C13.8731 7.78125 14.1092 8.01736 14.1092 8.30859C14.1092 8.59983 13.8731 8.83594 13.5819 8.83594H7.25409C6.96285 8.83594 6.72678 8.59983 6.72678 8.30859C6.72678 8.01736 6.96289 7.78125 7.25409 7.78125ZM7.25409 9.89062H13.5819C13.8731 9.89062 14.1092 10.1267 14.1092 10.418C14.1092 10.7092 13.8731 10.9453 13.5819 10.9453H7.25409C6.96285 10.9453 6.72678 10.7092 6.72678 10.418C6.72678 10.1267 6.96289 9.89062 7.25409 9.89062ZM6.72678 12.5273C6.72678 12.2361 6.96285 12 7.25409 12H13.5819C13.8731 12 14.1092 12.2361 14.1092 12.5273C14.1092 12.8186 13.8731 13.0547 13.5819 13.0547H7.25409C6.96289 13.0547 6.72678 12.8186 6.72678 12.5273Z" fill="#F6F6F6"/>
            </svg>
            <span>{{ $t('Chat') }}</span>
        </a>
    </div>
</template>

<script>
import OfferSellerInfo from './OfferSellerInfo.vue';
import Modal from '../../../../components/Modal.vue';

export default {
    components: {
        OfferSellerInfo,
        Modal
    },
    props: {
      seller: {
        type: Object,
        required: true
      },
      offer: {
        type: Object,
        required: true
      },
      mobile: {
        type: Boolean,
        default: false
      },
      showModalSellerInfo: {
        tupe: Boolean,
        default: false
      }
    },
    emits: ['close:modal'],
    data() {
        return {
            language: window.common.language.code2
        };
    },
    methods: {
        formatCurrency(count, isPercent = false) {
            const formatted = Number(count)
                .toFixed(isPercent ? 2 : 0)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                .replace(',', '.');

            if(isPercent) {
                return `${formatted}%`
            } else {
                return `${formatted}`
            }
        },
        getNegativeFeedback(count, allFeed) {
            if (allFeed <= 0) {
                this.formatCurrency(0, true);
            }
            const negative = 100 - count;

            return this.formatCurrency(negative, true);
        },
        getUtcOffset(timezone, updated_at) {
            const date = new Date(updated_at);
            const offsetMinutes = -date.getTimezoneOffset();

            const sign = offsetMinutes >= 0 ? '+' : '-';
            const hours = String(Math.floor(Math.abs(offsetMinutes) / 60)).padStart(2, '0');
            const minutes = String(Math.abs(offsetMinutes) % 60).padStart(2, '0');

            return `${timezone} ${sign}${hours}:${minutes}`;
        }
    }
};
</script>

<style lang="scss">
    .seller-tooltip{
        pointer-events: none;
        opacity: 0;
        position: absolute;
        box-shadow: 0px 0px 15px 0px #00000026;
        padding: 12px 15px;
        border-radius: 16px;
        background-color: #fff;
        transition: 0.4s;
        z-index: 100;
        min-width: 303px;
        top: 55px;
        &::before{
            content: '';
            z-index: 1;
            position: absolute;
            top: -30px;
            left: 0;
            width: 100%;
            height: 50px;
            background-color: transparent;
        }
        &__row{
            z-index: 2;
            position: relative;
            display: flex;
            gap: 20px;
            justify-content: space-between;
            padding-bottom: 15px;
            &.rate{
                padding-top: 15px;
                margin-top: 15px;
                padding-bottom: 10px;
                border-top: 1px solid #E5E5E5;
            }
            &.feedbacks{
                padding-top: 15px;
                border-top: 1px solid #E5E5E5;
                padding-bottom: 15px;
            }
            &-col{
                display: flex;
                flex-direction: column;
                gap: 5px;
                width: 100%;
                &-text{
                    font-family: "Avenir-Next";
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 120%;
                    letter-spacing: 0px;
                    color: #9D9D9D;
                }
                &-value{
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 120%;
                    letter-spacing: 0px;
                    color: #1F1F1F;
                    &.positive{
                        color: #1F8C1C;
                    }
                    &.negative{
                        color: #F43232;
                    }
                }
            }
        }
        &__btn{
            z-index: 2;
            position: relative;
            background-color: #F75A01;
            height: 50px;
            width: 100%;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            span{
                color: #fff;
                font-family: "Avenir-Next";
                font-weight: 400;
                font-size: 16px;
            }
        }
    }
    .seller-tooltip-modal{
        padding: 12px 15px;
        border-radius: 16px 16px 0 0 !important;
        .close{
            display: flex;
            align-items: center;
            justify-content: center;
            top: 25px;
            right: 25px;
            opacity: 1;
        }
    }
</style>